import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '1', d: 'M50.8,21.1c0-1.5-1.2-2.6-2.7-2.6s-2.6,1.2-2.6,2.7l0.1,31.3c0,1.5,1.2,2.6,2.7,2.6s2.6-1.2,2.6-2.7L50.8,21.1z' }),
    React.createElement("path", { key: '2', d: 'M38.3,59.3H25.5c-2.4,0-4.2-1.9-4.2-4.2V20.2c0-2.4,1.9-4.2,4.2-4.2h12.9c2.4,0,4.2,1.9,4.2,4.2v34.9\n\tC42.7,57.4,40.8,59.3,38.3,59.3z' }),
    React.createElement("path", { key: '3', d: 'M18.4,21.1c0-1.5-1.2-2.6-2.7-2.6s-2.6,1.2-2.6,2.7l0.1,31.3c0,1.5,1.2,2.6,2.7,2.6s2.6-1.2,2.6-2.7L18.4,21.1z' }),
], 'TransportCoverDualIcon');
const TransportCoverDualIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportCoverDualIcon);
